import styles from "@/components/common/styles/warning-text.module.scss";
import Image from "next/image";
import warningIcon from "@/assets/icons/train-error-icon.svg";

type WarningTextProps = {
  text: string;
};

const WarningText = ({ text }: WarningTextProps) => {
  return (
    <div className={styles.warning_content_wrapper}>
      <Image alt={"waring"} src={warningIcon} height={24} width={24} />
      <div className={styles.text_wrapper}>
        <div className={styles.warning_text}>Warning:&nbsp;</div>
        <div className={styles.warning_content_text}>{text}</div>
      </div>
    </div>
  );
};

export default WarningText;
